import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as HiIcons from "react-icons/hi";

const Intro = () => {
  return (
    <motion.div className="intro" id="intro">
      <div className="intro-text-container">
        <div className="intro-text-left">
          <motion.p
            initial={{
              opacity: 0.75,
              clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
            }}
            whileInView={{
              opacity: 1,
              clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
            }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Helping design digital products to <span>power</span> the future
          </motion.p>
        </div>
        <div className="intro-text-right">
          <motion.p
            initial={{
              opacity: 0,
              transform: "scale(1.01)",
            }}
            whileInView={{
              opacity: 1,
              transform: "scale(1.02)",
            }}
            transition={{ duration: 0.25, delay: 0.1 }}
          >
            Driven by curiosity and new technologies, I am continuously pushing
            the boundaries to create immersive, emotional and joyful experiences
            that blur the lines of reality through imagery and 3D animations
          </motion.p>
        </div>
      </div>
      <motion.div
        className="intro-btn-container"
        initial={{
          opacity: 0,
          transform: "scale(1.01)",
        }}
        whileInView={{
          opacity: 1,
          transform: "scale(1.02)",
        }}
        transition={{ duration: 0.25, delay: 0.5 }}
      >
        <Link className="intro-btn" to="/About">
          <p>
            About me
            <span>
              <HiIcons.HiOutlineArrowNarrowRight />
            </span>
          </p>
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default Intro;
